import React, { useState, useEffect } from "react";

const MyIpAddress = () => {
  const [ipAddress, setIpAddress] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIpAddress(data.ip);
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
  }, []);

  return (
    <div className="ip-container">
      <h1>Your IP Address</h1>
      {ipAddress ? (
        <p className="ip-address">{ipAddress}</p>
      ) : (
        <p className="loading-text">Loading...</p>
      )}
    </div>
  );
};

export default MyIpAddress;
